import { useEffect } from 'react'
import Reports from '@pages/Reports'
import { postToParent } from './embedAuth'

// Chromeless catalog. Reuses the regular Reports page (tiles, tabs, search,
// icons) verbatim — only difference is tile clicks navigate to /embed/reports/:id
// so the user stays inside the iframe instead of bouncing to the chrome shell.

const EmbedReportsList = () => {
  useEffect(() => {
    postToParent({ type: 'cb2-reports-list-mounted' })
    const onResize = () => {
      postToParent({
        type: 'cb2-resize',
        height: document.documentElement.scrollHeight,
      })
    }
    onResize()
    const ro = new ResizeObserver(onResize)
    ro.observe(document.documentElement)
    return () => ro.disconnect()
  }, [])

  /*
   * `p-6` stays, for the reason spelled out in EmbedReportView: the catalog it
   * wraps (`Reports.jsx`) renders `.report-shell`, and that class assumes a
   * 24px-padded parent it does not have here — there is no <main> on an embed
   * route. This div supplies it, so the embed gutter equals the app's exactly
   * (32 / 82 / 90px by breakpoint) after the A1 increase. Do not add padding to
   * both this and the shell.
   */
  return (
    <div className="bg-gray-50 min-h-screen p-6">
      <Reports linkPrefix="/embed/reports" />
    </div>
  )
}

export default EmbedReportsList
